import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useDateGroups } from '../../hooks/useDates';
import * as AppPropTypes from '../../lib/PropTypes';

import CardsList from './CardsList';

import styles from '../../../styles/lists/calendar.module.scss';

const propTypes = {
    items: AppPropTypes.films,
    groups: PropTypes.shape({
        items: AppPropTypes.films,
    }),
    cardProps: PropTypes.shape({}),
    isDark: PropTypes.bool,
    isIndex: PropTypes.bool,
    withStickyHeader: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    items: null,
    groups: null,
    cardProps: null,
    isDark: false,
    isIndex: false,
    withStickyHeader: false,
    className: null,
};

// TODO: think: transform this into a FilmsCarousel-like self-loading list?

const CalendarList = ({
    items,
    groups: parentGroups,
    cardProps,
    isDark,
    isIndex,
    withStickyHeader,
    className,
}) => {
    const groups = useDateGroups(parentGroups === null ? items : null, 'YYYY-MM-DD', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
    });

    const finalGroups = parentGroups || groups;

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {(finalGroups || []).map((group, i) => (
                <CardsList
                    className={styles.group}
                    key={`${group?.id}-${i + 1}`}
                    id={group.id}
                    title={group.title}
                    items={group.items}
                    cardType="event"
                    isDark={isDark}
                    withStickyHeader={withStickyHeader}
                    headerClassName={classNames([
                        styles.header,
                        { [styles.higherSticky]: isIndex },
                    ])}
                    listClassName={styles.list}
                    cardProps={cardProps}
                    withRef
                />
            ))}
        </div>
    );
};

CalendarList.propTypes = propTypes;
CalendarList.defaultProps = defaultProps;

export default CalendarList;
